<section class="layout__spotlight">
  <div class="layout__spotlight__priority-info">
    <h1 class="layout__spotlight__page-header">{{ pageHeader }}</h1>
    <div class="d-flex layout__spotlight__navbar-row">
      <div class="flex-grow-1">
        <rad-tab-group class="rad-theme--light layout__spotlight__tab-menu" size="large" new-tab-button="false" 
          (tabChanged)="onTabChanged($event)">
          <rad-tab
            *ngFor="let tab of menuItems"
            [attr.label]="tab.label"
            [attr.selected]="tab.selected"
          ></rad-tab>
        </rad-tab-group>  
      </div>
      <ng-content select="[navbar-after]"></ng-content>
    </div>
  </div>
</section>
  
<section class="layout__page-container" *ngIf="activateFn && isTabsLoaded" #layoutContainer>
  <div class="layout__page-container__content">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
</section>
